import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=69858393&scoped=true"
import script from "./CardFooter.vue?vue&type=script&lang=js"
export * from "./CardFooter.vue?vue&type=script&lang=js"
import style0 from "./CardFooter.vue?vue&type=style&index=0&id=69858393&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69858393",
  null
  
)

export default component.exports